export const Paths = {
  Organizations: {
    Base: (organizationId: string) => `organizations/${organizationId}`,
    Members: {
      Base: (organizationId: string) =>
        `${Paths.Organizations.Base(organizationId)}/members`,
      Uid: (organizationId: string, memberUid: string) =>
        `${Paths.Organizations.Members.Base(organizationId)}/${memberUid}`,
    },
  },
}
